export default __webpack_public_path__ + "static/918-3bc1b59a94d7e916bdeba5562de5a84c.gif";